import useListOneTicketsQuery from './useListOneTicketsQuery';
import useListOneTicketQuery from './useListOneTicketQuery';
import useListOneTicketHistoryQuery from './useListOneTicketHistoryQuery';
import useListOneTicketStudiesQuery from './useListOneTicketStudiesQuery';
import useListOneStatusesQuery from './useListOneStatusesQuery';
import useListOneApprovalQuery from './useListOneApprovalQuery';
import useListOneStatusCountsQuery, {
  LIST_ONE_STATUS_TABS,
} from './useListOneStatusCountsQuery';

export {
  useListOneTicketsQuery,
  useListOneTicketQuery,
  useListOneTicketHistoryQuery,
  useListOneTicketStudiesQuery,
  useListOneStatusesQuery,
  useListOneApprovalQuery,
  useListOneStatusCountsQuery,
  LIST_ONE_STATUS_TABS,
};
